import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <main
        data-testid="auth-loading"
        className="min-h-screen bg-black text-white flex items-center justify-center"
      >
        <div className="font-mono text-xs uppercase tracking-[0.3em] text-acid">
          loading...
        </div>
      </main>
    );
  }

  if (!user) {
    return (
      <Navigate
        to="/login"
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return children;
}
